import type { ReactNode } from "react";

export type IconName =
  | "home"
  | "screen"
  | "media"
  | "list"
  | "shield"
  | "life"
  | "user"
  | "more"
  | "search"
  | "x"
  | "upload"
  | "chevron"
  | "alert"
  | "logout"
  | "mail"
  | "eye"
  | "eyeOff"
  | "check"
  | "play";

const paths: Record<IconName, ReactNode> = {
  home: (
    <>
      <path d="M4 10.5 12 4l8 6.5" />
      <path d="M6 10.2V20h12V10.2" />
      <path d="M10 20v-5h4v5" />
    </>
  ),
  screen: (
    <>
      <rect x="3" y="4" width="18" height="13" rx="2" />
      <path d="M8 21h8" />
      <path d="M12 17v4" />
    </>
  ),
  media: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m10 9 6 3-6 3z" />
    </>
  ),
  list: (
    <>
      <path d="M9 7h11M9 12h11M9 17h11" />
      <path d="M4.5 7h.01M4.5 12h.01M4.5 17h.01" />
    </>
  ),
  shield: <path d="M12 3 5 6v6c0 3.8 2.8 6.4 7 8 4.2-1.6 7-4.2 7-8V6z" />,
  life: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="3" />
      <path d="m6.8 6.8 2.4 2.4M14.8 14.8l2.4 2.4M17.2 6.8l-2.4 2.4M9.2 14.8l-2.4 2.4" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="3.2" />
      <path d="M5.2 19.2c1.4-2.8 3.6-4.2 6.8-4.2s5.4 1.4 6.8 4.2" />
    </>
  ),
  more: (
    <>
      <circle cx="6" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="18" cy="12" r="1.2" fill="currentColor" stroke="none" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 4 4" />
    </>
  ),
  x: <path d="M6 6l12 12M18 6 6 18" />,
  upload: (
    <>
      <path d="M12 16V6" />
      <path d="m8 9.5 4-4 4 4" />
      <path d="M5 19h14" />
    </>
  ),
  chevron: <path d="m9 6 6 6-6 6" />,
  alert: (
    <>
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
      <path d="m10.3 4.8-7.5 13.2A2 2 0 0 0 4.5 21h15a2 2 0 0 0 1.7-3L13.7 4.8a2 2 0 0 0-3.4 0z" />
    </>
  ),
  logout: (
    <>
      <path d="M10 7V5h9v14h-9v-2" />
      <path d="M4 12h10" />
      <path d="m11 9 3 3-3 3" />
    </>
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </>
  ),
  eye: (
    <>
      <path d="M2.5 12S6.5 6.5 12 6.5 21.5 12 21.5 12 17.5 17.5 12 17.5 2.5 12 2.5 12z" />
      <circle cx="12" cy="12" r="2.5" />
    </>
  ),
  eyeOff: (
    <>
      <path d="M4 4l16 16" />
      <path d="M10.2 6.4A10 10 0 0 1 12 6c5.5 0 9.5 6 9.5 6a16 16 0 0 1-3.1 3.6" />
      <path d="M6.2 6.7C4 8.3 2.5 12 2.5 12S6.5 18 12 18c1.4 0 2.7-.3 3.8-.8" />
    </>
  ),
  check: <path d="m5 12 5 5L20 7" />,
  play: <path d="M8 6.5v11l9-5.5z" />,
};

export function Icon({ name, size = 20 }: { name: IconName; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name]}
    </svg>
  );
}
